import { SERVER_API } from "@/utils/constant"
export  default {
    icon: "el-icon-menu",
    title: "魔方",
    name: "magicCube",
    timestamp: "1665385357481001",
    setUp: {
        tabVal: 0
    },
    magicCube:{
        title: '魔方样式',
        modeNumber: 4,
        boxList:[],
    },
    bgStyle: {
        title: "背景样式",
        name: "bgStyle",
        type: 1,
        list: [
            {
                val: "直角",
                icon: "el-icon-edit-outline"
            },
            {
                val: "圆角",
                icon: "el-icon-c-scale-to-original"
            }
        ]
    },
    padding:{
        title: "内部边距",
        val: 0,
        min: 0
    },
    lrEdge: {
        title: "左右边距",
        val: 10,
        min: 0
    },
    mbConfig: {
        title: "页面间距",
        val: 12,
        min: 0
    },
}